import { SupportedCountries } from '../../../../../types/supportedCountries'
import { VatDeclarationStatus } from '../types/vatDeclarationStatus'

const vatDeclarationStatusesCommon: VatDeclarationStatus[] = [
  {
    variant: 'primary',
    translationKey: 'vat_declarations.table.statuses_info.draft',
  },
  {
    variant: 'warning',
    translationKey: 'vat_declarations.table.statuses_info.ready_to_submit_or_pay',
  },
  {
    variant: 'error',
    translationKey: 'vat_declarations.table.statuses_info.overdue',
  },
  {
    variant: 'success',
    translationKey: 'vat_declarations.table.statuses_info.paid',
  },
]

const vatDeclarationStatusesNL: VatDeclarationStatus[] = [
  {
    variant: 'primary',
    translationKey: 'vat_declarations.table.statuses_info.draft_or_pending',
  },
  {
    variant: 'error',
    translationKey: 'vat_declarations.table.statuses_info.overdue_or_submission_failed',
  },
  {
    variant: 'warning',
    translationKey: 'vat_declarations.table.statuses_info.ready_to_submit_or_pay',
  },
  {
    variant: 'success',
    translationKey: 'vat_declarations.table.statuses_info.paid',
  },
]

export const vatDeclarationStatuses: Record<SupportedCountries, VatDeclarationStatus[]> = {
  DE: vatDeclarationStatusesCommon,
  DK: vatDeclarationStatusesCommon,
  FO: vatDeclarationStatusesCommon,
  FR: vatDeclarationStatusesCommon,
  GL: vatDeclarationStatusesCommon,
  NL: vatDeclarationStatusesNL,
}
